import { render, staticRenderFns } from "./GoodsSwiper.vue?vue&type=template&id=344856e3&scoped=true"
import script from "./GoodsSwiper.vue?vue&type=script&lang=js"
export * from "./GoodsSwiper.vue?vue&type=script&lang=js"
import style0 from "./GoodsSwiper.vue?vue&type=style&index=0&id=344856e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344856e3",
  null
  
)

export default component.exports